export default {
  amountOfDaysForNearSchedule: 2,
};
